import styled from 'styled-components';
import { mixins } from '@jarvis/react-portal-addons';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 1;
  max-width: 1660px; // 1920 is the max content width (side menu + content area), side menu is 260px.
  padding-bottom: 16px;

  ${mixins.md(`
    gap: 20px;
  `)}

  ${mixins.lg(`
    gap: 24px;
    padding: 24px 32px;
  `)}

  ${mixins.xl(`
    margin: auto;
    padding: 28px 36px;
    gap: 28px;
  `)}
`;

export const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(12, 1fr);
  position: relative;
  max-width: 1660px; // 1920 is the max content width (side menu + content area), side menu is 260px.
  z-index: 1;
  padding: 0 16px;

  ${mixins.md(`
    gap: 20px;
    padding: 0 28px;
  `)}

  ${mixins.lg(`
    gap: 24px;
    padding: unset;
  `)}

  ${mixins.xl(`
    gap: 28px;
  `)}
`;

export const PrivatePickupContainer = styled.div`
  grid-column: 1 / span 12;

  align-self: center;
  display: flex;
  justify-content: center;
  ${mixins.xl(`
    justify-content: flex-start;
    grid-column: 1 / span 8;
  `)}
`;

export const SideCardsContainer = styled.div`
  grid-column: 1 / span 12;

  align-self: flex-start;
  display: flex;
  gap: 24px;
  flex-direction: column;
  grid-column: span 12;

  ${mixins.xl(`
    flex-direction: column;
    justify-content: center;
    grid-column: -5 / -1;
  `)}

  ${mixins.xxxl(`
    gap: 28px;
  `)}
`;
